import Link from "next/link";
import dayjs from "utils/dayjs";
import classNames from "classnames/bind";
import UIIcon from "common/blocks/UIIcon";
import styles from "./Announcement.module.scss";
import { InvestorAnnouncementModel } from "models/investorAnnouncementsModel";

const cx = classNames.bind(styles);

export interface AnnouncementsProps {
    investorAnnouncements: InvestorAnnouncementModel[];
}

export default function Announcement({ investorAnnouncements }: AnnouncementsProps) {
    return (
        <div>
            {investorAnnouncements.map((announcement) => (
                <div className={cx("announcement")}>
                    <Link key={announcement.storyID} href={announcement.pdfUrl} target="_blank">
                        <p className={cx("announcement-date")}>
                            {dayjs(announcement.timestamp).format("DD MMMM YYYY")}
                        </p>
                        <div className={cx("announcement-item")}>
                            <h3>{announcement.headline}</h3>
                            <UIIcon icon={"ChevronRight"} className={cx("icon")} />
                        </div>
                    </Link>
                </div>
            ))}
        </div>
    );
}
